<template>
  <!-- 粉丝 -->
  <div class="cont-fensi cont-haoyou page-question">
    <ul class="user-much-num clearfix">
      <li
        v-for="(item, index) in selects"
        :key="index"
        :class="{active: showIndex === index}"
        @click="showEvent(index)"
      >
      <span>{{item}}</span>
      </li>
    </ul>
    <div class="ques-list home-list" v-if="showIndex === 0">
      <div class="ques-item">
        <div class="xs-price">悬赏<br>￥350</div>
        <div class="item-tit">
          <router-link to="/gquestionsdetail">iclone7常见的问题：如何改变默认类型是切线类型？</router-link>
          <span class="state">已采纳最佳答案</span>
        </div>
        <div class="asker-tags clearfix">
          <router-link to="" class="ask-info">
            <span class="ask-avatar" :style="{'background-image': 'url(' + require('@/assets/images/user_avatar.jpg') + ')'}"></span>
            <span class="ask-name">提问者</span>
          </router-link>
          <ul class="tags clearfix">
            <li>#标签一</li>
            <li>#标签二</li>
            <li>#标签三</li>
          </ul>
        </div>
        <div class="ask-content">
          <router-link to="/gquestionsdetail">
            优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付
          </router-link>
        </div>
        <div class="ans-user-much clearfix">
          <div class="ans-user clearfix">
            <span class="t-tips">2天前</span>
          </div>
          <div class="much">
            <span class="item">访问量<span class="num">1.5k</span></span>
            <span class="item">回答数<span class="num">5</span></span>
          </div>
        </div>
      </div>
      <div class="ques-item">
        <div class="item-tit">
          <router-link to="/gquestionsdetail">iclone7常见的问题：如何改变默认类型是切线类型？</router-link>
          <span class="state">尚无评选最佳</span>
        </div>
        <div class="asker-tags clearfix">
          <router-link to="" class="ask-info">
            <span class="ask-avatar" :style="{'background-image': 'url(' + require('@/assets/images/user_avatar.jpg') + ')'}"></span>
            <span class="ask-name">提问者</span>
          </router-link>
          <ul class="tags clearfix">
            <li>#标签一</li>
            <li>#标签二</li>
            <li>#标签三</li>
          </ul>
        </div>
        <div class="ask-content">
          <router-link to="/gquestionsdetail">
            优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付
          </router-link>
        </div>
        <div class="ans-user-much clearfix">
          <div class="ans-user clearfix">
            <span class="t-tips">2天前</span>
          </div>
          <div class="much">
            <span class="item">访问量<span class="num">1.5k</span></span>
            <span class="item">回答数<span class="num">5</span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="ques-list home-list" v-if="showIndex === 1">
      <div class="ques-item">
        <div class="item-tit">
          <router-link to="/home/wenda/detail?userId=1">iclone7常见的问题：如何改变默认类型是切线类型？</router-link>
          <span class="state">最佳回答</span>
        </div>
        <div class="asker-tags clearfix">
          <router-link to="" class="ask-info">
            <span class="ask-avatar" :style="{'background-image': 'url(' + require('@/assets/images/user_avatar.jpg') + ')'}"></span>
            <span class="ask-name">提问者</span>
          </router-link>
          <ul class="tags clearfix">
            <li>#标签一</li>
            <li>#标签二</li>
            <li>#标签三</li>
          </ul>
        </div>
        <div class="ask-content">
          <router-link to="/home/wenda/detail?userId=1">
            优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付
          </router-link>
        </div>
        <div class="ans-user-much clearfix">
          <div class="ans-user clearfix">
            <span class="t-tips">2天前</span>
          </div>
          <div class="much">
            <span class="item">收藏<span class="num">35</span></span>
            <span class="item">点赞<span class="num">25</span></span>
            <span class="item">回复<span class="num">5</span></span>
          </div>
        </div>
      </div>
      <div class="ques-item">
        <div class="item-tit">
          <router-link to="/home/wenda/detail?userId=1">iclone7常见的问题：如何改变默认类型是切线类型？</router-link>
        </div>
        <div class="asker-tags clearfix">
          <router-link to="" class="ask-info">
            <span class="ask-avatar" :style="{'background-image': 'url(' + require('@/assets/images/user_avatar.jpg') + ')'}"></span>
            <span class="ask-name">提问者</span>
          </router-link>
          <ul class="tags clearfix">
            <li>#标签一</li>
            <li>#标签二</li>
            <li>#标签三</li>
          </ul>
        </div>
        <div class="ask-content">
          <router-link to="/home/wenda/detail?userId=1">
            优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付
          </router-link>
        </div>
        <div class="ans-user-much clearfix">
          <div class="ans-user clearfix">
            <span class="t-tips">2天前</span>
          </div>
          <div class="much">
            <span class="item">收藏<span class="num">35</span></span>
            <span class="item">点赞<span class="num">25</span></span>
            <span class="item">回复<span class="num">5</span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="ques-list home-list" v-if="showIndex === 2">
      <div class="ques-item">
        <div class="xs-price">悬赏<br>￥350</div>
        <div class="item-tit">
          <router-link to="/gquestionsdetail">iclone7常见的问题：如何改变默认类型是切线类型？</router-link>
          <span class="state">已采纳最佳答案</span>
        </div>
        <div class="asker-tags clearfix">
          <router-link to="" class="ask-info">
            <span class="ask-avatar" :style="{'background-image': 'url(' + require('@/assets/images/user_avatar.jpg') + ')'}"></span>
            <span class="ask-name">提问者</span>
          </router-link>
          <ul class="tags clearfix">
            <li>#标签一</li>
            <li>#标签二</li>
            <li>#标签三</li>
          </ul>
        </div>
        <div class="ask-content">
          <router-link to="/gquestionsdetail">
            优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付
          </router-link>
        </div>
        <div class="ans-user-much clearfix">
          <div class="ans-user clearfix">
            <span class="t-tips">2天前</span>
          </div>
          <div class="much">
            <span class="item">访问量<span class="num">1.5k</span></span>
            <span class="item">回答数<span class="num">5</span></span>
            <span class="item">点赞<span class="num">50</span></span>
            <span class="item">关注<span class="num">100</span></span>
          </div>
        </div>
      </div>
      <div class="ques-item">
        <div class="item-tit">
          <router-link to="/gquestionsdetail">iclone7常见的问题：如何改变默认类型是切线类型？</router-link>
          <span class="state">尚无评选最佳</span>
        </div>
        <div class="asker-tags clearfix">
          <router-link to="" class="ask-info">
            <span class="ask-avatar" :style="{'background-image': 'url(' + require('@/assets/images/user_avatar.jpg') + ')'}"></span>
            <span class="ask-name">提问者</span>
          </router-link>
          <ul class="tags clearfix">
            <li>#标签一</li>
            <li>#标签二</li>
            <li>#标签三</li>
          </ul>
        </div>
        <div class="ask-content">
          <router-link to="/gquestionsdetail">
            优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付
          </router-link>
        </div>
        <div class="ans-user-much clearfix">
          <div class="ans-user clearfix">
            <span class="t-tips">2天前</span>
          </div>
          <div class="much">
            <span class="item">访问量<span class="num">1.5k</span></span>
            <span class="item">回答数<span class="num">5</span></span>
            <span class="item">点赞<span class="num">50</span></span>
            <span class="item">关注<span class="num">100</span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  components: {

  },
  data () {
    return {
      showIndex: 0,
      selects: ['我的提问', '我的回答', '我的关注']
    }
  },
  mounted () {
    this.initSelect()
  },
  methods: {
    initSelect () {
      const selectId = Number(this.$route.query.selectId) || 0
      this.showIndex = selectId > this.selects.length - 1 ? 0 : selectId
    },
    showEvent (num) {
      this.showIndex = num
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/stylePublic.less";
.cont-haoyou{
  &.cont-fensi{
    padding-top: 0px;
  }
  .user-much-num{
    li{
      float: left;
      margin-right: 20px;
      font-size: 14px;
      cursor: pointer;
      &.active{
        position: relative;
        &:after{
          position: absolute;
          bottom: 0;
          left: 0;
          content: '';
          display: block;
          width: 100%;
          height: 2px;
          background: #515151;
        }
      }
      &.red{
        span{
          position: relative;
          &:after{
            position: absolute;
            right: -5px;
            top: -5px;
            content: '';
            display: block;
            width: 8px;
            height: 8px;
            background: #ff0000;
            border-radius: 50%;
          }
        }
      }
    }
  }
  .ques-list{
    padding-left: 0;
    background: #fff;
    .ques-item{
      border-bottom: 2px solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .cont-haoyou{
    margin-top: 30px;
    .user-much-num{
      top: -30px !important;
      line-height: 30px !important;
    }
  }
}
</style>
